import { RicosPluginToolbarNames } from 'ricos-types';
import { DEFAULT_CONFIG } from './constants.js';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { tiptapExtensionsMap } from './tiptap/tiptap.js';
import { LINK_BUTTON_TYPE, ACTION_BUTTON_TYPE } from './types.js';
import 'ricos-schema';
import 'ricos-schema/dist/statics/button.defaults.json';
import 'wix-rich-content-editor-common';
import './icons/InsertPluginIcon.js';
import 'react';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-toolbars-ui';
import './modals/SettingsModal.js';
import 'ricos-context';
import './modals/SettingsModalContent.js';
import 'ricos-styles';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './components/design-component.js';
import './toggled-color-picker-07116f3d.js';
import './components/color-toggle-component.js';
import 'classnames';
import './dataHooks.js';
import './defaults.js';
import './utils/isDefined.js';
import './components/settings-component.js';
import 'wix-rich-content-toolbars-modals';
import 'ricos-content';
import './tiptap/component.js';
import './viewer/button-viewer.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginButton = (type, config, toolbarName) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config),
    type,
    toolbar: {
      names: [toolbarName],
      getButtons: (config2, services) => getToolbarButtons(config2, services, type)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services, type),
    tiptapExtensions: tiptapExtensionsMap[type]
  };
};
const pluginLinkButton = (config) => {
  return pluginButton(LINK_BUTTON_TYPE, config, RicosPluginToolbarNames.LINK_BUTTON);
};
const pluginActionButton = (config) => {
  return pluginButton(ACTION_BUTTON_TYPE, config, RicosPluginToolbarNames.ACTION_BUTTON);
};

export { pluginActionButton, pluginLinkButton };
//# sourceMappingURL=editor.js.map
